import product_orders from "../views/product-orders/index.vue";
import product_orders_detail from "../views/product-orders/detail.vue";
import bank_accounts from "../views/product-orders/bank-accounts.vue";

const routes = [
  {
    path: "/product-orders",
    name: "product_orders",
    component: product_orders,
    meta: { authOnly: true }
  },
  {
    path: "/product-orders/:uuid",
    name: "product_orders_detail",
    component: product_orders_detail,
    meta: { authOnly: true }
  },
  {
    path: "/bank-accounts",
    name: "bank_accounts",
    component: bank_accounts,
    meta: { authOnly: true }
  }
];

export default routes;
